import React from 'react';
import styles from './index.module.scss';
import { DATE_FORMATS, formatDate } from '../../utils';

const ViewComparableItemModal = props => {
  const { itemDetails, toggleModal } = props;
  const { id, source, date, unit, price, image  } = itemDetails;

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            {/* <div className={styles['label']}>Comparable Item</div> */}
            <div className={styles['modal-title']}>Comparable Item</div>
          </div>
          <i className={'fa fa-times'} onClick={toggleModal} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['image-section']}>
            <div className={styles['image-container']}>
              {/* actual URL needs to be implemented once fixed */}
              <img src={image?._url} />
            </div>
          </div>
          <div className={styles['input-section']}>
            <div className={styles['input-group']}>
              <div className={styles['label']}>Item ID</div>
              <div className={styles['detail']}>{id}</div>
            </div>
            <div className={styles['input-group']}>
              <div className={styles['label']}>Source</div>
              <div className={styles['detail']}>{source}</div>
            </div>
            <div className={styles['input-group']}>
              <div className={styles['label']}>Date</div>
              <div className={styles['detail']}>{formatDate(date, DATE_FORMATS.YYYY_MM_DD)}</div>
            </div>
            <div className={styles['input-group']}>
              <div className={styles['label']}>Unit</div>
              <div className={styles['detail']}>{unit}</div>
            </div>
            <div className={styles['input-group']}>
              <div className={styles['label']}>Price</div>
              <div className={styles['detail']}>{price}</div>
            </div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <button
            className={styles['cancel-button']}
            onClick={toggleModal}
            disabled={false}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewComparableItemModal;
